import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getIntegrations } from 'services/account.service';
import { getSyncQueue } from 'services/rabbit.service';
import { loadIntegrations } from 'store/modules/settings/actions';
import { DATE_FORMAT } from 'utils';
import toast from 'utils/toast';

let integrationTimer = null;

const SyncStatusBanner = ({}) => {
  const [t] = useTranslation('settings');
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('queued');
  const [integration, setIntegration] = useState();
  const [noOfMessages, setNoOfMessages] = useState();
  const dispatch = useDispatch();
  const { syncIntegration, showBanner } = useSelector(
    (state) => state.settings.integrations,
  );

  useEffect(() => {
    if (syncIntegration) {
      getSyncQueue().then(setNoOfMessages);
      getIntegrations().then((resp) => {
        setIntegration(resp);
        const int = resp.find((i) => i.hash === syncIntegration.hash);
        setIntegration(int);
        setLoading(false);
      });
      integrationTimer = setInterval(() => {
        getIntegrations().then((resp) => {
          const int = resp.find((i) => i.hash === syncIntegration.hash);
          setIntegration(int);
        });
      }, 30000);
    }
    return () => {
      integrationTimer && clearInterval(integrationTimer);
    };
  }, [syncIntegration]);

  useEffect(() => {
    if (!integration) return;
    const {
      account_integration_last_queue_date,
      account_integration_last_run_date,
      account_integration_last_start_date,
    } = integration;
    const lastQueue = moment.utc(
      account_integration_last_queue_date,
      DATE_FORMAT,
    );
    const lastRun = moment.utc(account_integration_last_run_date, DATE_FORMAT);
    const lastStart = moment.utc(
      account_integration_last_start_date,
      DATE_FORMAT,
    );

    // const queued = lastRun.isBefore(lastStart)
    const hasStarted =
      lastStart.isSameOrAfter(lastQueue) ||
      lastStart.diff(lastQueue, 's') === 1; // starts right away
    // console.log('has started ', hasStarted, lastStart.diff(lastQueue, 's'));
    const hasDone = hasStarted && lastRun.isSameOrAfter(lastStart);
    // console.log('has done ', hasDone);
    // console.log(account_integration_last_queue_date, account_integration_last_start_date, account_integration_last_run_date);

    if (hasDone) {
      setStatus('done');
      clearInterval(integrationTimer);
      dispatch(loadIntegrations());
    } else if (hasStarted) setStatus('started');
  }, [integration]);

  useEffect(() => {
    const eta =
      noOfMessages === '0' ? '5+' : Math.ceil((+noOfMessages / 2) * 6);

    if (status === 'done') {
      toast.success(t('sync-completed', 'Sync Completed'));
    } else if (status === 'started') {
      toast.info(
        t('sync-eta', {
          defaultValue:
            'Sync Started. Estimated time to complete: {{eta}} minutes',
          eta,
        }),
      );
    }
  }, [status]);

  if (!showBanner) return null;

  return null;

  // return (
  //   <Root className={status}>
  //     <span className="msg">
  //       {status === 'started' && `Sync Started. Estimated time to complete: ${eta} minutes`}
  //       {status === 'queued' && 'Sync Queued'}
  //       {status === 'done' && 'Sync Completed'}
  //     </span>
  //     <span className="close" onClick={() => dispatch(toggleSyncBanner(false))}>&times;</span>
  //   </Root>
  // )
};

export default SyncStatusBanner;
